export default function () {
    $(document).on('click', '[data-access-code]', e => {
        e.preventDefault();

        const el = e.currentTarget;
        $('#access-code-panel .code').text(el.getAttribute('data-access-code'));
        $('#access-code-panel .email').text(el.getAttribute('data-participant-email'));
    });
};
